import React from 'react';
import Stepper from '../Stepper';
import { FinancialAccountNode, OrgNode } from '../../services/orgs/interfaces';
import { ShowPayable, StripeMetadataInput, SuccessData } from '../VaultForm';
import { Consumer, StripeEnv } from '../../util/enums';
import { useSteps } from './hooks/useSteps';

export default function CreateKybKyc({
  org,
  payableOrg,
  currentUserId,
  provider,
  showSavePayableCheckbox,
  financialAccountRoots,
  onClose,
  onSuccess,
  onRevealSuccess,
  onRevealFail,
  statementDescriptor,
  metadata,
  showSubmitForReviewButton,
  stripeEnv,
  token,
  embedded,
  raiseConfig,
  userKyc,
  fundraiserId,
  fundraiserSlug,
  consumer,
  onBankAccountWidgetFinishClick,
  onBankAccountWidgetSkipClick,
  showRaiseLastStep,
  shadow,
  showFaq,
}: {
  org?: OrgNode;
  payableOrg?: OrgNode;
  currentUserId?: string;
  onClose?: () => void;
  onSuccess: (res: SuccessData) => void;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  provider: VaultProvider;
  showSavePayableCheckbox: ShowPayable;
  financialAccountRoots: FinancialAccountNode[];
  statementDescriptor?: string;
  metadata?: StripeMetadataInput;
  showSubmitForReviewButton?: boolean;
  stripeEnv: StripeEnv;
  token: string;
  embedded?: boolean;
  raiseConfig?: {
    raiseCampaignId?: string;
    raiseUserId?: string;
  };
  userKyc?: Kyc;
  fundraiserId?: string | null;
  fundraiserSlug?: string | null;
  consumer: Consumer;
  onBankAccountWidgetFinishClick?: () => void;
  onBankAccountWidgetSkipClick?: () => void;
  showRaiseLastStep?: boolean;
  shadow?: boolean;
  showFaq?: boolean;
}): React.JSX.Element | null {
  const steps = useSteps({
    consumer,
    org,
    payableOrg,
    currentUserId,
    userKyc,
    provider,
    onSuccess,
    onRevealSuccess,
    onRevealFail,
    token,
    raiseConfig,
    showSavePayableCheckbox,
    financialAccountRoots,
    statementDescriptor,
    metadata,
    stripeEnv,
    fundraiserId,
    fundraiserSlug,
    onBankAccountWidgetFinishClick,
    onBankAccountWidgetSkipClick,
    onClose,
    showRaiseLastStep,
    showSubmitForReviewButton: showSubmitForReviewButton || false,
  });
  if (steps.length > 0) {
    return (
      <Stepper
        pages={steps}
        showSubmitForReviewButton={showSubmitForReviewButton}
        embedded={embedded}
        consumer={consumer}
        shadow={shadow}
        showFaq={showFaq}
      />
    );
  } else {
    return null;
  }
}
